import { queryOptions } from '@tanstack/react-query'
import getApiResponseData from '@utils/get-api-response-data'
import axios from 'axios'

import { api } from '../api/api'
import { key } from './key'

const retryRequest = (failureCount: number, error: unknown) => {
  if (failureCount >= 1 || !axios.isAxiosError(error)) {
    return false
  }

  const status = error.response?.status

  return status === undefined || (status >= 500 && status < 600)
}

export const getRequest = (id: string) =>
  queryOptions({
    queryKey: key('request', id),
    queryFn: async () => {
      const { data } = await api.getRequest(id)
      const request = getApiResponseData(data)?.request

      if (!request) {
        throw new Error('fulfillment request snapshot returned no request')
      }

      return request
    },
    retry: retryRequest,
    // Снимок читается один раз на открытие формы и дальше не перечитывается сам: продавец
    // правит заявку долго, а любой фоновый запрос — при возврате в окно, восстановлении сети
    // или перерисовке — принёс бы другую версию заявки под уже набранным текстом.
    staleTime: Infinity,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
